import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "link";

const STYLE: Record<Variant, { background: string; color: string; border: string }> = {
  primary: { background: "var(--sk-action)", color: "var(--sk-action-text)", border: "none" }, // 4,8:1
  secondary: {
    background: "var(--sk-surface)",
    color: "var(--sk-title)",
    border: "1.5px solid var(--sk-border)",
  },
  link: { background: "transparent", color: "var(--sk-link)", border: "none" },
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  /** Action en cours : bouton désactivé, texte remplacé. */
  busy?: boolean;
  busyLabel?: string;
}

/** Bouton unique de l'application : 44 px de haut minimum, bleu Konnect pour l'action principale. */
export function Button({
  variant = "primary",
  busy,
  busyLabel,
  disabled,
  children,
  style,
  ...rest
}: ButtonProps) {
  const s = STYLE[variant];
  const off = disabled || busy;
  return (
    <button
      type="button"
      {...rest}
      disabled={off}
      aria-busy={busy || undefined}
      style={{
        ...s,
        minHeight: variant === "link" ? 44 : 52,
        // Icône (lucide-react) et texte alignés sur la même ligne.
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        width: variant === "link" ? "auto" : "100%",
        padding: "10px 16px",
        borderRadius: "var(--sk-radius-pill)",
        fontFamily: "var(--font-sans)",
        fontSize: 16,
        fontWeight: 600,
        cursor: off ? "default" : "pointer",
        opacity: off ? 0.55 : 1,
        boxShadow: variant === "primary" && !off ? "0 6px 16px rgb(57 101 250 / 0.30)" : "none",
        textDecoration: variant === "link" ? "underline" : "none",
        ...style,
      }}
    >
      {busy && busyLabel ? busyLabel : children}
    </button>
  );
}
